module.exports = __webpack_public_path__ + "static/media/pro-miikka-salminen.44fadf8e.webp";